import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username:'', email:'', password:'', full_name:'' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await register(form);
      navigate('/spaces');
    } catch(err) {
      setError(err.error || 'Registration failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)', padding:'20px' }}>
      <div style={{ width:'100%', maxWidth:'420px' }}>
        <div style={{ display:'flex', alignItems:'center', gap:'10px', justifyContent:'center', marginBottom:'40px' }}>
          <div style={{ width:'38px', height:'38px', borderRadius:'10px', background:'var(--brand)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'18px', fontWeight:'700', color:'#fff' }}>F</div>
          <span style={{ fontSize:'22px', fontWeight:'700' }}>EOMP</span>
        </div>
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-xl)', padding:'32px' }}>
          <h2 style={{ fontSize:'20px', fontWeight:'700', marginBottom:'6px' }}>Create your account</h2>
          <p style={{ color:'var(--muted)', fontSize:'13px', marginBottom:'24px' }}>Join your team's workspace</p>
          {error && <div style={{ background:'var(--red-dim)', border:'1px solid var(--red)', borderRadius:'var(--radius)', padding:'10px 12px', color:'var(--red)', fontSize:'13px', marginBottom:'16px' }}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Full Name</label>
              <input className="input" value={form.full_name} onChange={e=>setForm({...form,full_name:e.target.value})} placeholder="Your full name" required/>
            </div>
            <div className="form-group">
              <label className="form-label">Username</label>
              <input className="input" value={form.username} onChange={e=>setForm({...form,username:e.target.value})} placeholder="Choose a username" required/>
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="input" type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="Your email" required/>
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input className="input" type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} placeholder="Min. 8 characters" required minLength={8}/>
            </div>
            <button className="btn btn-primary" style={{ width:'100%', justifyContent:'center', padding:'10px', marginTop:'8px' }} disabled={loading}>
              {loading ? 'Creating account…' : 'Create Account'}
            </button>
          </form>
          <p style={{ textAlign:'center', marginTop:'20px', color:'var(--muted)', fontSize:'13px' }}>
            Already have an account? <Link to="/login" style={{ color:'var(--brand-mid)', textDecoration:'none' }}>Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
